var exports = {
  "k": "x61f99309--8261d6--container",
};

module.exports = exports;
